import { injectable, inject } from 'inversify';
import { GetAllProductsUseCase } from '../../../domain/usecases/ProductUseCases';
import type { ProductRepository } from '../../../domain/repositories/ProductRepository';
import { Product } from '../../../domain/models';
import { TYPES } from '../../../di/types';

/**
 * Implementation of GetAllProductsUseCase
 * This contains the business logic for retrieving all products
 */
@injectable()
export class GetAllProductsUseCaseImpl implements GetAllProductsUseCase {
  constructor(
    @inject(TYPES.ProductRepository) private readonly productRepository: ProductRepository
  ) {}

  async execute(branchId: string, page = 1, limit = 50): Promise<{
    products: Product[];
    total: number;
    hasMore: boolean;
  }> {
    try {
      // Validate input parameters
      this.validateParameters(branchId, page, limit);

      // Get products from repository
      const result = await this.productRepository.findAll(branchId, page, limit);

      // Filter products with valid stock
      const validProducts = result.products.filter(_product => {
        // if (product.stock < 0) {
        //   console.warn(`Product ${product.name} has negative stock: ${product.stock}. Excluding from results.`);
        //   return false;
        // }
        return true; // For now, include all products regardless of stock
      });

      // Apply business rules for product listing
      return {
        products: this.applyBusinessRules(validProducts),
        total: result.total,
        hasMore: result.hasMore
      };
    } catch (error) {
      console.error('Get all products failed:', error);
      throw error;
    }
  }

  private validateParameters(branchId: string, page: number, limit: number): void {
    if (!branchId || branchId.trim().length === 0) {
      throw new Error('Branch ID is required');
    }

    if (page < 1) {
      throw new Error('Page number must be greater than 0');
    }

    if (limit < 1 || limit > 100) {
      throw new Error('Limit must be between 1 and 100');
    }
  }

  private applyBusinessRules(products: Product[]): Product[] {
    return products.filter(product => {
      // Business rule: Only show active products
      if (!product.isActive) {
        return false;
      }

      // Note: Stock checking moved to BranchInventoryRepository
      // Old: Only return products with stock >= 0
      // if (product.stock < 0) {
      //   return false;
      // }

      return true;
    });
  }
} 